export default function ProductSpotlight() {
	return (
		<section id='work' className='bg-slate-950 border-t border-blue-900/30'>
			<div className='mx-auto max-w-6xl px-6 py-20'>
				<h2 className='font-display text-3xl sm:text-4xl font-semibold tracking-tight text-white'>
					CrikIT product suite
				</h2>
				<p className='mt-4 max-w-3xl text-blue-100/80'>
					CrikIT builds AI-enabled tools that streamline cricket operations
					end-to-end—from league governance to match-day decisioning—so
					organizations can deliver world-class experiences with less manual
					overhead.
				</p>
				<div className='mt-10 grid gap-8 lg:grid-cols-2'>
					<article className='flex h-full flex-col rounded-3xl border border-blue-900/40 bg-slate-900/60 p-8 shadow-lg shadow-blue-900/20 transition-transform duration-200 hover:-translate-y-1 hover:shadow-blue-800/40'>
						<h3 className='font-display text-2xl font-semibold tracking-tight text-white'>
							CrikIT — Enterprise sports management platform
						</h3>
						<p className='mt-4 text-blue-100/80'>
							End-to-end operations suite for leagues at scale. Automates
							registration, scheduling, scoring, and insights in one platform.
						</p>
						<div className='mt-10 flex flex-wrap gap-4 pt-4 lg:mt-auto lg:pt-6'>
							<a
								href='https://crikit.io'
								target='_blank'
								rel='noopener noreferrer'
								className='rounded-2xl bg-blue-600 px-5 py-3 font-medium text-white transition-colors hover:bg-blue-500 focus-ring'>
								Explore Platform
							</a>
							<a
								href='mailto:team@asmakam.com'
								className='rounded-2xl border border-blue-400/30 px-5 py-3 font-medium text-blue-100 transition-colors hover:bg-blue-900/30 focus-ring'>
								Schedule Consultation
							</a>
						</div>
					</article>
					<article className='flex h-full flex-col rounded-3xl border border-blue-900/40 bg-slate-900/60 p-8 shadow-lg shadow-blue-900/20 transition-transform duration-200 hover:-translate-y-1 hover:shadow-blue-800/40'>
						<h3 className='font-display text-2xl font-semibold tracking-tight text-white'>
							Duckworth-Lewis-Stern (DLS) Calculator
						</h3>
						<p className='mt-4 text-blue-100/80'>
							Fast DLS calculator for rain-affected fixtures. Input match
							context, compare scenarios, and share revised targets instantly.
						</p>
						<div className='mt-10 flex flex-wrap gap-4 pt-4 lg:mt-auto lg:pt-6'>
							<a
								href='https://dls.crikit.io/'
								target='_blank'
								rel='noopener noreferrer'
								className='rounded-2xl bg-blue-600 px-5 py-3 font-medium text-white transition-colors hover:bg-blue-500 focus-ring'>
								Launch Calculator
							</a>
							<a
								href='https://crikit.freshdesk.com/a/solutions/articles/43000722332'
								target='_blank'
								rel='noopener noreferrer'
								className='rounded-2xl border border-blue-400/30 px-5 py-3 font-medium text-blue-100 transition-colors hover:bg-blue-900/30 focus-ring'>
								View Help Guide
							</a>
						</div>
					</article>
				</div>
			</div>
		</section>
	);
}
